// scene 事件
export var SceneEventList = ['loaded', 'fontloaded', 'maploaded', 'resize', 'destroy', 'dragstart', 'dragging', 'dragend', 'dragcancel'];